import ModuleBase, { moduleInit, ViewLayer, bindButtonClickEvent, implementFunction, bindToggleClickEvent } from "../../../../framework/core/mvvm/module_base";
import ChatView, { ChatType } from "./chat_view";
import { Notify } from "../../server/notify/proto_notify";
import NotifyServer from "../../server/notify/notify_server";
import ModelData from "../../../public/model_data";
import TimeManager from "../../../../manager/time_manager";
import ModelBase from "../../../../framework/core/mvvm/model_base";

import { chat_data } from "./chat_data";
import ModuleManager from "../../../../framework/core/module_manager";
import Horn from "./horn";
import { friend_utils } from "../friend/friend_utils";
import { IUserCurrencyData } from "../../../../manager/user_manager";
import PlayerIconModule from "../playericon/playerIcon";
import AppData from '../../../public/const/app_data';
import Utility from "../../../../utility/utility";
import Shop from "../shop/shop";
import AppController from "../../../../sdk/app_controller";

const { ccclass } = cc._decorator;

export enum ContentTypeEnum {
    text = 1,//文本     
    img = 2,//图片
    voice = 3,//语音

    wait = 101,//等待消息
    start_greet = 102,//会话开始
    end_greet = 103,//会话结束
    user_end_greet = 104,//客户会话结束信息
    time_out_warning = 105,//会话超时警告
    time_out_end_greet = 106,//会话超时结束信息
    custom_greet = 107,//客服问候语
    offLine_greet = 108,//离线会话问候语
    plaer_cancel_order = 109,//玩家取消订单
    order_audit_finish = 110,//订单审核完成
    bank_info = 200,//银商银行信息
    bank_order_greet = 201, //银商重置订单问候语
    bank_order_detail = 202,//银商重置订单详情



}


@ccclass
@moduleInit("Chat")
export default class Chat extends ModuleBase<ChatView, null> {

    LastSendChatTime: number;
    allFriendMsgList: Notify.ChatMessage[] = []  //所有私聊信息

    sendLastFriendMsg: Notify.IChatMessage = null
    _model: ModelBase = new ModelBase()

    private currency: number;
    private avatarId: number;
    private friendFromModule: number;
    private playToggleSound: boolean;

    private friendModuleCallHideCallback


    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = 'package/hall/module/chat/chat';
        this.viewType = ChatView;
        //this.needViewMask = true
        //this.clickAnywhereClose = true;
        this.playToggleSound = true;

    }
    onInit() {
        this.eventBind("Event_Notify_World_Chat", this.on_world_chat_data.bind(this))
        this.eventBind("Event_Notify_Customer_Chat_Data", this.on_private_chat_data.bind(this))
        this.eventBind("friend_remove_friend", this.on_remove_friend);
        this.eventBind("Event_Chat_Click_OtherInfoAvatar", (uid) => {
            ModuleManager.instance.showModule<PlayerIconModule>(PlayerIconModule, { userId: uid, other: true })
        })

        this.view.chatScroll.setParntent(this.view)
        this.view.initTableView();

    }

    @bindToggleClickEvent("world")
    onWorldToggle() {
        if (this.playToggleSound) {
            Utility.playButtonSound();
        }
        this.view.showWorldChatPanel();
        this.playToggleSound = true;
    }

    @bindButtonClickEvent("Mask")
    onMask() {
        let self = this;
        this.view.tweenTo(null, true, () => {
            self.hide();
        })
    }

    @bindToggleClickEvent("friend")
    onFriendToggle() {

        if (this.playToggleSound) {
            Utility.playButtonSound();
        }

        this.view.showFriendListPanel(this.friendFromModule);
        this.friendFromModule = 0
        this.playToggleSound = true;
    }

    @bindToggleClickEvent("club")
    onClubToggle() {

        Utility.playButtonSound();
    }

    protected onButtonClick(node: cc.Node) {
        if (node.name == "txt" && node.parent.name == "talkBg") {
            let str = node.getComponent(cc.Label).string
            cc.log("chatLabel:",str)
            AppController.instance.copyTextToClipboard(str)
            str = str.replace(/[\r\n]/g,""); 
            if (str.indexOf("http") > -1) {
                var reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
                var url = str.match(reg);
                cc.log("检测到url：",url)
                if(url.length > 0){
                    cc.sys.openURL(url[0])
                }
            }
        }

    }
    
    onShow(arg0) {

        this.view.tweenTo(null);
        this.showPanel(arg0);
    }

    private showPanel(arg0) {

        this.friendModuleCallHideCallback = null
        this.refreshFriendChatData();

        if (arg0) {
            let playerId = arg0 ? arg0["friendId"] : 0;
            if (playerId) {
                if (!this.view.friendToggle.isChecked) {
                    this.friendFromModule = playerId;
                    //主动触发的不播放声音
                    this.playToggleSound = false;
                    this.view.friendToggle.check();

                } else {
                    this.view.showFriendListPanel(playerId)
                }
            }
            this.friendModuleCallHideCallback = arg0["chatHideCallback"]
        }
        else {
            if (!this.view.worldToggle.isChecked) {
                this.playToggleSound = false;
                this.view.worldToggle.check();
            } else {
                this.view.showWorldChatPanel();
            }
        }
    }

    public refreshFriendChatData() {

        this.view.chatScroll.allFriendChatData = chat_data.getFriendData()

    }

    @implementFunction('onSelfCurrencyDataUpdate')
    protected on_selfCurrencyDataUpdate(data: IUserCurrencyData) {

        this.currency = data.chip;

    }

    @bindButtonClickEvent("hornBtn")
    onClickHorn() {

        ModuleManager.instance.showModule<Shop>(Shop, { tag: "tag_daoju" })

    }

    @bindButtonClickEvent("quickChatBgBtn")
    onQuickChatBgBtn() {

        this.view.quickChatNode.active = false;
    }

    @bindButtonClickEvent("quickChatBtn")
    onQuickChat() {

        this.view.quickChatNode.active = true;
    }

    @bindButtonClickEvent("transfer")
    onTransfer() {

        this.view.transferFriend(this.currency);
    }

    @bindButtonClickEvent("info")
    onFriendInfo() {

        ModuleManager.instance.showModule<PlayerIconModule>(PlayerIconModule, { userId: this.view.curFriendId, other: true })
    }

    @bindButtonClickEvent("delete")
    onDelete() {

        // let self = this;
        // friend_utils.removeFriend(this.view.curFriendId,this,(result)=>{
        //     if (result) {
        //         self.view.updateFriendListView();
        //     }
        // });

        //删除聊天记录

        let self = this;
        ModuleManager.instance.showDialogConfirmCancel("ลบประวัติการแชทหรือไม่", () => {
            chat_data.clearFriendData(self.view.curFriendId)
            self.refreshFriendChatData();
            self.view.chatScroll.curChatFrientData = []
            self.view.setData(ChatType.friendChat, [], self.view.mPrivateTableView);
            self.view.filterPlayer(self.view.curFriendId)
        });
    }

    @bindButtonClickEvent("reconnect")
    onReconnect() {

        NotifyServer.instance.reconnectServer();
    }

    hide() {
        super.hide();
        this.friendModuleCallHideCallback && this.friendModuleCallHideCallback()
    }


    @bindButtonClickEvent("sendBtn")
    onClickSend() {
        let AppRunningTime = TimeManager.instance.AppRunningTime
        if (this.LastSendChatTime > 0 && this.LastSendChatTime + 2 > AppRunningTime) {
            ModuleManager.instance.toast("สนทนานี้บ่อยเกินไป  โปรดหยุดพักก่อนค่ะ")
            return
        }
        this.LastSendChatTime = AppRunningTime
        if (this.view.inputTxt.string == "") {
            return
        }

        if (this.view.curChatType == ChatType.friendChat || this.view.curChatType == ChatType.friendList) {
            this.sendToFriend()
        }
        else {
            if (AppData.testMode && AppData.userConnectEnvi == 0) {
                ModuleManager.instance.toast("测试用户暂不允许在正式服的世界频道发言")
                return
            }

            if (Number(this.view.hornNumLab.string) < 1) {
                ModuleManager.instance.toast("จำนวนไอเทมไม่พอ");
                return;
            }
            this.sendToWorld()
        }

    }
    sendToFriend(msg?: string) {

        let gender = ModelData.instance.roleData.gender;

        let playerId = this.view.curFriendId;

        let self = this;
        friend_utils.isFriend(playerId, this, (result) => {
            if (!result) {
                ModuleManager.instance.toastKey("friend_is_not_friend");
                self.view.updateFriendListView();
                return;
            }
        });

        let str = {
            content: msg ? msg : this.view.inputTxt.string,
            avatar: ModelData.instance.roleData.avatar,
            nickName: ModelData.instance.roleData.name,
            gender: gender,
            lastChatTime: Date.parse(new Date().toString())//加上时间戳
        }
        let stringify = JSON.stringify(str)
        let chatmsg: Notify.IChatMessage = {
            sender: ModelData.instance.userToken,
            recver: "",
            sendUserId: ModelData.instance.roleData.id,
            recverUserId: playerId,
            recverType: "player",
            content: stringify,
        }

        this.sendLastFriendMsg = chatmsg
        NotifyServer.instance.sendPlayerChatMessage(chatmsg)

        this.view.inputTxt.string = "";
    }

    sendToWorld() {

        let self = this;
        if (false) {

            let gender = ModelData.instance.roleData.gender;

            let content: Notify.GroupChatMessage.IGroupChatContent = {
                userId: ModelData.instance.roleData.id,
                nickName: ModelData.instance.roleData.name,
                avatar: ModelData.instance.roleData.avatar,
                groupChatName: "world",
                content: JSON.stringify({ content: this.view.inputTxt.string, gender: gender }),
            }


            let alist: Notify.GroupChatMessage.IGroupChatContent[] = []
            alist.push(content)

            this.view.inputTxt.string = " "
            NotifyServer.instance.sendGroupChatMessage({
                contentList: alist
            })

        } else {

            let gender = ModelData.instance.roleData.gender;
            //this.view.inputTxt.string=""
            let requestData: IHttpRequestData = {
                baseUrl: 'chat/horn?',
                params: {
                    gameUserId: ModelData.instance.roleData.id,
                    groupChatName: "world",
                    content: JSON.stringify({ content: this.view.inputTxt.string, gender: gender/*, type : "horn"*/ }),
                }
            }
            this.apiHttpGet(requestData, (retData) => {

                if (retData.code == "SUCCESS") {
                    self.view.inputTxt.string = "";
                    self.view.updateHornNum(Number(self.view.hornNumLab.string) - 1);
                }
            })
        }

        //this.view.inputTxt.string = "";

    }

    /**
     * 世界聊天
     * @param chatMsg 
     */
    on_world_chat_data(reset: boolean, chatList: Notify.GroupChatMessage.IGroupChatContent[]) {

        if (this.view.curChatType == ChatType.worldChat) {

            if (reset) {

                this.view.setData(ChatType.worldChat, chatList, this.view.mWorldTableView);
            } else {

                this.view.appendArry(ChatType.worldChat, chatList, this.view.mWorldTableView, true)
            }
        }
    }

    /**
     * 私聊
     * @param chatMsg 
     */
    private on_private_chat_data(chatMsg: Notify.ChatMessage) {

        this.avatarId = ModelData.instance.roleData.id;

        if (chatMsg.sendUserId == 0 && chatMsg.recverUserId == 0) {

            chatMsg.sender = this.sendLastFriendMsg.sender
            chatMsg.recver = this.sendLastFriendMsg.recver
            chatMsg.sendUserId = this.sendLastFriendMsg.sendUserId
            chatMsg.recverUserId = this.sendLastFriendMsg.recverUserId
            chatMsg.recverType = this.sendLastFriendMsg.recverType
            chatMsg.content = this.sendLastFriendMsg.content
        }

        chat_data.saveFriendData(chatMsg)

        //发送者是自己
        if (chatMsg.sendUserId == this.avatarId) {

            this.view.chatScroll.allFriendChatData.push(chatMsg)

            if (this.view.curChatType == ChatType.friendChat) {

                let refreshItem = this.view.topFriend(chatMsg.recverUserId, true)
                if (!refreshItem && this.view.curFriendId == Number(chatMsg.recverUserId)) {
                    this.view.appendOne(ChatType.friendChat, chatMsg, this.view.mPrivateTableView, true);
                }
            }
        }
        else {

            //发送者是其他人 判断是不是你的好友
            friend_utils.isFriend(chatMsg.sendUserId, this, (result) => {
                if (result) {
                    this.view.chatScroll.allFriendChatData.push(chatMsg)

                    if (this.view.curChatType == ChatType.friendChat) {

                        let refreshItem = this.view.topFriend(chatMsg.sendUserId, false);
                        if (!refreshItem && this.view.curFriendId == Number(chatMsg.sendUserId)) {
                            this.view.appendOne(ChatType.friendChat, chatMsg, this.view.mPrivateTableView, true);
                        }
                    }
                }
            })

        }
    }

    private on_remove_friend(friendId: number) {

        this.view.updateFriendListView();
    }




}
